import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, User, Home, BarChart3, Menu, X } from "lucide-react";

const Navbar = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const email = localStorage.getItem("userEmail");
  const role = localStorage.getItem("userRole") || "student";

  const handleLogout = () => {
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userRole");
    navigate("/login");
  };

  const handleNavigate = (path) => {
    setIsMobileMenuOpen(false);
    navigate(path);
  };

  return (
    <nav className="navbar" data-testid="navbar">
      <div className="navbar-container">
        <div className="navbar-brand" onClick={() => handleNavigate("/dashboard")} data-testid="navbar-brand">
          <BarChart3 size={28} />
          <span>CarNav</span>
        </div>

        <button
          className="navbar-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>

        <div className={`rounded-lg navbar-menu ${isMobileMenuOpen ? "open" : ""}`}>
          <div className="navbar-user">
            <User size={18} />
            <span>{email} {role === "admin" ? "(Admin)" : ""}</span>
          </div>

          <button
            type="button"
            className="navbar-logout"
            onClick={handleLogout}
            data-testid="logout-button"
          >
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
